import { useState, useEffect } from 'react'
import { FormGroup, FormFeedback } from 'reactstrap'
import { useSelector } from 'react-redux'
import { renderUnit, isZeroDay } from 'core/service/insured/age'
import messages from 'core/data-model/constants/messages'
import Date from '../../../common-components/date-dropdown'
import { Dropdown } from 'common-components'
import { _getEntryAge } from 'core/service/insured/validation'
import { dateFormatterPattern } from 'core/service/lib/date'
import { getServiceWrapper } from 'core/service-wrapper'
import { getSelectedDisplayProductQuery } from 'quick-quote/product-selection/selectors'
import { isReviseQQFlow } from 'quick-quote/selectors'

import { convertAgeToBirthdate, getAgeOptions } from '../utils'

const Birthdate = (props) => {
  const { birthdate, editBirthdate, age, errorBirthdateMessage } = props

  const isReviseFNAOnQQ = useSelector((state) => isReviseQQFlow(state))
  const displayProductQuery = useSelector((state) => getSelectedDisplayProductQuery(state))
  const [entryAgeYear, setEntryAgeYear] = useState({ min: 0, max: 99 })

  useEffect(() => {
    const setupAgeYear = async () => {
      const serviceWrapper = getServiceWrapper()
      const basicPlan = await serviceWrapper.getBasicPlan(displayProductQuery)
      const entryAge = await _getEntryAge(basicPlan, false)
      if (entryAge) {
        const minimumAge = entryAge.minimum.unit !== 'year' ? 0 : entryAge.minimum.value
        const maximumAge = entryAge.maximum.value

        onEntryAgeYear({ min: minimumAge, max: maximumAge })
      }
    }

    if (isReviseFNAOnQQ) {
      setupAgeYear()
    }
  }, [])

  const onEntryAgeYear = (year) => {
    setEntryAgeYear({ min: year.min, max: year.max })
  }

  const ageOptions = getAgeOptions(entryAgeYear.min, entryAgeYear.max)

  return (
    <FormGroup className={`birthdate-selection ${errorBirthdateMessage !== '' ? 'has-danger' : ''}`}>
      {isReviseFNAOnQQ ? (
        <>
          <div>
            <div className="birthdate-input">
              <label>{messages.AGE_SELECT_LABEL}</label>
              <Dropdown
                testId="ageSelect"
                options={ageOptions}
                onChange={(value) => {
                  const newBirthdate = convertAgeToBirthdate(value)
                  editBirthdate(newBirthdate)
                }}
                value={errorBirthdateMessage !== '' ? '' : age.unit === 'year' ? age.value : 0}
                placeHolder="กรุณาเลือก"
              />
            </div>
            <div className="insured-age-select">
              <p>{renderUnit('year')}</p>
            </div>
          </div>
          <FormFeedback className="validation-message">{errorBirthdateMessage}</FormFeedback>
          <FormFeedback className="info-message attached-icon">
            <p dangerouslySetInnerHTML={{ __html: messages.AGE_SELECT_FYI }} />
          </FormFeedback>
        </>
      ) : (
        <>
          <div className="birthdate-input">
            <label>{messages.BIRTHDATE_LABEL}</label>
            <Date
              id="birthdate"
              className="form-control"
              type="tel"
              pattern={dateFormatterPattern}
              placeholder={messages.BIRTHDATE_PLACEHOLDER}
              value={birthdate}
              onChange={(e) => {
                editBirthdate(e.target.value)
              }}
            />
            <FormFeedback className="validation-message">{errorBirthdateMessage}</FormFeedback>
          </div>
          <div className="insured-age">
            <label>อายุ</label>
            <p className="age-number">
              {isZeroDay(age) ? '-' : age.value}&nbsp;
              <small>{isZeroDay(age) ? renderUnit('year') : renderUnit(age.unit)}</small>
            </p>
          </div>
        </>
      )}
    </FormGroup>
  )
}

export default Birthdate
